<template>
  <div>
    <h2>Search</h2>
    <v-alert :value="true" type="info"
      >Search using the filter boxes at the top of the columns. Sort by clicking
      the column name. Click a row to go to the quote.</v-alert
    >
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2><v-icon>search</v-icon>Filter Records</h2>
        </template>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model.number="filters.id"
                    label="Id"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.leadid"
                    label="Lead id"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.name" label="Name" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.address"
                    label="Email"
                    outline
                  />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="filters.telephone"
                    label="Telephone"
                    outline
                  />
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn @click="searchFilters" :loading="loading">
              <v-icon>search</v-icon>
              <span>&#160;Search</span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="count"
      :loading="loading"
      :headers="headers"
      :items="quotes"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <router-link
              :to="{ name: 'quote', params: { id: props.item.id } }"
              >{{ props.item.id }}</router-link
            >
          </td>
          <td>{{ props.item.leadid }}</td>
          <td>{{ props.item.name }}</td>
          <td v-if="props.item.emails">
            <div v-for="email in props.item.emails" :key="email.id">
              <a :href="`mailto:${email.address}`">{{ email.address }}</a>
              <span>&#160;</span>
              <span>&lt;{{ email.personal }}&gt;</span>
              <span>&#160;</span>
              <a @click="navigateEmail(props.item, email)">
                <v-icon small>launch</v-icon>
              </a>
            </div>
          </td>
          <td v-if="!props.item.emails">
            <v-progress-circular indeterminate color="info" />
          </td>
          <td>
            <Telephone :value="props.item.telephone" />
          </td>
          <td>{{ props.item.timestamp | formatDateTime }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Telephone from "@/components/quote/extras/Telephone";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Search",
  metaInfo() {
    return {
      title: "Search",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { Telephone },
  computed: {
    firstRow() {
      const { page, rowsPerPage } = this.pagination;
      return (page - 1) * rowsPerPage;
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Lead id",
          value: "leadid"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Email",
          value: "address"
        },
        {
          text: "Telephone",
          value: "telephone"
        },
        {
          text: "Timestamp",
          value: "timestamp"
        }
      ],
      count: 0,
      quotes: [],
      emails: null,
      filters: {
        id: null,
        leadid: null,
        name: null,
        address: null,
        telephone: null,
        timestamp: null
      },
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      },
      showFirstLastPage: true,
      showCurrentPage: true,
      panel: []
    };
  },
  methods: {
    async fetchQuotes(rowsPerPage) {
      const response = await nbmlaw.post(
        `/cors/admin/sales/quotes/search/${this.firstRow}/${rowsPerPage}`,
        this.filters
      );
      // console.log(response.data);
      this.quotes = response.data;
      this.loading = false;
    },
    async fetchCount() {
      const response = await nbmlaw.post(
        `/cors/admin/sales/quotes/search/count`,
        this.filters
      );
      // console.log(response.data)
      this.count = response.data;
    },
    update() {
      this.loading = true;
      const { sortBy, descending, rowsPerPage } = this.pagination;
      if (rowsPerPage != -1) {
        this.filters.sortBy = sortBy;
        this.filters.descending = descending;
        this.fetchCount();
        this.fetchQuotes(rowsPerPage);
        // this.fetchEmails(rowsPerPage);
      } else {
        this.pagination.rowsPerPage = 10;
      }
    },
    searchFilters() {
      this.pagination.page = 1;
      this.update();
    },
    navigateEmail(item, email) {
      this.$router.push({
        name: "quoteEmail",
        params: { id: item.id, emailId: email.id }
      });
    }
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true
    },
    filters: {
      deep: true,
      handler() {
        if (this.filters.id == "") {
          this.filters.id = null;
        }
      }
    }
  },
  created() {
    this.update();
  }
};
</script>